module.exports = __webpack_public_path__ + "info-new-active.svg?ee8f5283d8f4918570dbc9c15d8d434f";